/**
 * A origem de módulo do Fee Fixo, do lado do front — o `origem_modulo` que
 * viaja no corpo do `POST /chat` (rota única do motor de IA, spec-010 [T030]).
 *
 * ★ Este arquivo NASCEU como `constants/personas.js` (spec-005 do
 * `project-onboarding-with-ai-fee-fixo`) e guardava o id da persona
 * (`ESPECIALISTA_FEE_FIXO`) que fixava agente e rota via o endpoint DEDICADO
 * `/fee-fixo/chat`. A spec-010 aposenta as duas rotas dedicadas (US-7,
 * D6/ADR-30): o roteamento passa a ser do Supervisor, e o que o front ainda
 * declara é só de ONDE a pergunta partiu — `origem_modulo`, eixo ORTOGONAL à
 * persona/ao agente. Renomeado no [T030] porque é o que sobra: nenhum
 * vocabulário de persona pertence mais ao front do Fee Fixo.
 *
 * O valor é o mesmo que o backend valida contra a allow-list
 * `ORIGENS_MODULO` (`aawz_intelligence_v2/constants/personas.py:322-328`) e
 * grava para separar o custo desta superfície do resto do relatório por
 * escritório — divergir aqui não quebra ruidosamente: o backend recusa o
 * valor desconhecido e cai no `DEFAULT_ORIGEM_MODULO` (`intelligence-v2`), e o
 * turno segue respondendo, só que carimbado como se tivesse vindo da tela
 * genérica. Espelho do backend em `OrigemDoModulo.unit.js`.
 *
 * ⚠️ NÃO confundir com o eixo de LISTAGEM de conversas
 * (`GET /conversations?context=`), que continua sendo `persona`/`context`
 * até a spec-010 [T031] reescrever `conversation_context.py` sobre Hub — esse
 * valor mora em `api/apiFeeFixoConversas.js`, local e sem exportação daqui,
 * porque é um eixo diferente com prazo de vida diferente.
 *
 * @see aawz-web-backend/src/aawz_intelligence_v2/constants/personas.py:323
 */
export const ORIGEM_MODULO_FEE_FIXO = 'fee-fixo'
